import React, {FC, memo, useCallback, useMemo} from "react";
import './TopBar2.css'
import {useStateValue} from "../state-provider/StateProvider";
import {setGridAreaContent} from "../app/App.action";

const TopBarComponent: FC<{ }> = ({

}) => {

  const [{ brand, header, items, brandFollowing, translations, gridAreaContent, partnership }, dispatch] = useStateValue()

  const brandFollowButtonClick = useCallback(() => {

    if (gridAreaContent !== 'BrandFollowForm') {
      dispatch(setGridAreaContent('BrandFollowForm'))
    } else {
      dispatch(setGridAreaContent('Grid'))
    }
  }, [dispatch, gridAreaContent])

  const partnershipText = useMemo(() => {
    const text = translations['HeaderPartnershipText']
    const parts = text?.split("{0}")

    return (
      <>
        { parts && (
          <span>
            {parts[0]}
            <b>{partnership}</b>
            {parts[1]}
          </span>
        )}
      </>
    )
  }, [partnership, translations])

  return (
    <div className={"top-bar"}>
      <div className={"top-bar-avatar"}>
        {brand?.imageLink && (
          <img
            draggable="false"
            alt="brand name"
            src={brand?.imageLink}
            className="top-bar-avatar-image"
          />
        )}
      </div>
      <div className={"top-bar-brand-name-wrapper"}>
        <div className={"top-bar-brand-name"}>
          <b>{brand?.title}</b>
        </div>
        { partnership && (
          <div className={"top-bar-brand-partnership"}>
            {partnershipText}
          </div>
        )}
      </div>
      <div className={"top-bar-action"}>
        <button className="top-bar-action-follow-button" onClick={brandFollowButtonClick}>
          {brandFollowing ? translations['FollowHeaderButtonLabelFollowing'] : translations['FollowHeaderButtonLabelFollow']}
        </button>
      </div>
    </div>
  )
}

export const TopBar = memo(TopBarComponent)